import { put, select, takeLatest } from 'redux-saga/effects'
import { getSceneDescriptionSelector } from '../selectors'
import { ISceneDescriptionState } from '../store/sceneDescription.types'
import { SceneDescriptionConstants } from '../store/sceneDescription.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import {
  closeFirstOnSceneMessage,
  saveSceneDescriptionState,
  setOtherAgencies,
} from '../store/sceneDescription.actions'

export function* cancelFirstOnSceneUpdate() {
  const { otherAgencies, firstOnSceneKey, firstOnScenePreviousValue }: ISceneDescriptionState = yield select(
    getSceneDescriptionSelector
  )

  const updatedOtherAgencies = otherAgencies.map((otherAgency) => {
    if (otherAgency.key === firstOnSceneKey) {
      return {
        ...otherAgency,
        firstOnScene: firstOnScenePreviousValue,
      }
    }
    return otherAgency
  })

  yield put(setOtherAgencies(updatedOtherAgencies))
  yield put(closeFirstOnSceneMessage())
  yield put(saveSceneDescriptionState())
}

export function* cancelFirstOnSceneUpdateSaga() {
  yield takeLatest(
    [SceneDescriptionConstants.CANCEL_FIRST_ON_SCENE_UPDATE],
    performWithMutexHOG,
    cancelFirstOnSceneUpdate
  )
}
